import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { MapElement } from '../../../shared/map/map-element.model';
import { Point } from 'geojson';
import { take } from 'rxjs/operators';
import { BaseComponent } from '../../../components/general/base/base.component';

import { MapService } from '../../../shared/map/map.service';
import { FocusActionService } from './focus-action.service';

/**
 * Focus feature means flying to feature and selecting it (the eye icon)
 * in contrast to FollowTrain feature, which centers a train and starts
 * following it.
 */
@Component({
  selector: 'qm-focus-action',
  templateUrl: './focus-action.component.html',
  styleUrls: ['./focus-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FocusActionComponent extends BaseComponent implements OnInit {

  @Input() selectedFeature: MapElement<Point>;

  constructor(private focusActionService: FocusActionService,
              private cdr: ChangeDetectorRef) {
    super();
    this.name = 'FocusActionComponent';
  }

  ngOnInit() {
  }

  /**
   * Should have tenant-specific logic
   */
  public setFocus() {
    this.focusActionService.setFocus(this.selectedFeature);
    this.cdr.markForCheck();
  }

}
